import * as actions from '../actions'
import * as Model from '../types/document'
import { Menu } from 'src/view/WithContextMenu';
import { Cursor } from 'src/lib/Cursor';


export function definitionMenuMaker(definitionC: Cursor<Model.Definition>) {
  return () => actions.act((): Menu => [{
    type: 'heading',
    heading: "FUNCTION"
  }, {
    type: 'contents',
    contents: "Duplicate function",
    onClick: () => actions.act(() => { actions.duplicateDefinition(definitionC) })
  }, {
    type: 'contents',
    contents: definitionC._('isVisualization').get() ? "Disable visualization" : "Enable visualization",
    onClick: () => actions.act(() => { definitionC.select('isVisualization').update((isIt) => !isIt)})
  }, {
    type: 'contents',
    contents: "Delete function",
    onClick: () => actions.act(() => { actions.deleteDefinition(definitionC) })
  }])
}


// WEBPACK FOOTER //
// ./src/view/definitionMenuMaker.ts